import { Pagination } from 'react-bootstrap';

type MonitoringTablePaginationProps = {
  page: number;
  totalPages: number;
  total: number;
  rangeStart: number;
  rangeEnd: number;
  itemLabel: string;
  busy?: boolean;
  onPageChange: (page: number) => void;
  visiblePages: number[];
  hasPrevEllipsis: boolean;
  hasNextEllipsis: boolean;
};

const MonitoringTablePagination = ({
  page,
  totalPages,
  total,
  rangeStart,
  rangeEnd,
  itemLabel,
  busy = false,
  onPageChange,
  visiblePages,
  hasPrevEllipsis,
  hasNextEllipsis
}: MonitoringTablePaginationProps) => {
  if (total <= 0) return null;

  return (
    <div className="realtime-monitoring-tab__table-footer">
      <p className="realtime-monitoring-tab__table-note mb-0">
        Showing {rangeStart}–{rangeEnd} of {total.toLocaleString()} {itemLabel}
        {busy ? ' · Loading…' : ''}
      </p>
      {totalPages > 1 ? (
        <Pagination className="realtime-monitoring-tab__pagination mb-0">
          <Pagination.Prev disabled={page <= 1 || busy} onClick={() => onPageChange(Math.max(1, page - 1))} />
          {hasPrevEllipsis ? <Pagination.Ellipsis disabled /> : null}
          {visiblePages.map(pageNo => (
            <Pagination.Item key={pageNo} active={pageNo === page} disabled={busy} onClick={() => onPageChange(pageNo)}>
              {pageNo}
            </Pagination.Item>
          ))}
          {hasNextEllipsis ? <Pagination.Ellipsis disabled /> : null}
          <Pagination.Next
            disabled={page >= totalPages || busy}
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          />
        </Pagination>
      ) : null}
    </div>
  );
};

export default MonitoringTablePagination;
